import "core-js/modules/es6.string.link";
import TopBar from "./TopBar.vue";
import Header from "./Header.vue";
export default {
  name: 'Layout',
  components: {
    'top-bar': TopBar,
    'global-header': Header
  },
  data: function data() {
    return {
      isBigDevice: false,
      windowWidth: window.innerWidth,
      txt: ''
    };
  },
  computed: {
    sidebar: function sidebar() {
      return this.$store.state.app.sidebar;
    },
    device: function device() {
      return this.$store.state.app.device;
    },
    classObj: function classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      };
    }
  },
  watch: {
    windowWidth: function windowWidth(newWidth, oldWidth) {
      this.txt = "it changed to ".concat(newWidth, " from ").concat(oldWidth);
      window.addEventListener('resize', this.onResize);
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      window.addEventListener('resize', _this.onResize);
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    handleClickOutside: function handleClickOutside() {
      this.$store.dispatch('closeSideBar', {
        withoutAnimation: false
      });
    },
    // routeLink(link) {
    //   if (link && link !== '') {
    //     this.$router.push({ path: link })
    //   }
    // },
    onNotificationReceived: function onNotificationReceived(t) {
      var _this2 = this;
      this.$notify({
        title: t.message,
        duration: 0,
        dangerouslyUseHTMLString: true,
        type: 'warning',
        onClick: function onClick() {
          return _this2.$router.push({
            path: t.link
          });
        }
      });
    },
    onResize: function onResize() {
      // Geçici kapatıldı
      // this.windowWidth = window.innerWidth
      // if (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent)) {
      //   this.isBigDevice = true
      //   // console.log('innerWidth', window.innerWidth)
      //   // console.log('isBigDevice', this.isBigDevice)
      // } else {
      //   this.isBigDevice = false
      // }
    }
  }
};